import React from 'react';
import RepVisitsUnlockPremiumView from '../RepVisitsUnlockPremiumView';
import ratingsUnlockAuthorizedRoleMessages from './ratings-unlock-authorized-role-messages';
import ratingsUnlockUnAuthorizedRoleMessages from './ratings-unlock-unauthorized-role-messages';
import { authorizedWithRole } from '../Authorization';
import * as constants from '../Authorization/constants';
import PageTitle from '../../components/PageTitle';

const authorizedRolePremiumProps = {
  activeStyle: 'ratings',
  messages: ratingsUnlockAuthorizedRoleMessages,
};

const unauthorizedRolePremiumProps = {
  activeStyle: 'ratings',
  messages: ratingsUnlockUnAuthorizedRoleMessages,
  isUnauthorizedRole: true,
};

export const Authorized = () => <RepVisitsUnlockPremiumView {...authorizedRolePremiumProps} />;
export const Unauthorized = () => <RepVisitsUnlockPremiumView {...unauthorizedRolePremiumProps} />;

const RepVisitsRatingsUnlockPage = authorizedWithRole(constants.ADMIN_ROLE, { failure: Unauthorized })(Authorized);

export default () => (
  <div>
    <PageTitle title="RepVisits" category="Intersect" />
    <RepVisitsRatingsUnlockPage />
  </div>
);
